import {Fab, Fade, useScrollTrigger} from "@mui/material";
import {KeyboardArrowUp} from "@mui/icons-material";
import {FC, ReactElement} from "react";

interface IProps {
    children: ReactElement
}

const ScrollTopContainer: FC<IProps> = (props) => {
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        target: window,
        disableHysteresis: true,
        threshold: 100,
    });

    const handleClick = () => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    };

    return (
        <>
            {props.children}
            <Fade in={trigger}>
                <Fab color="primary" size="small" aria-label="scroll back to top"
                     onClick={handleClick}
                     role="presentation"
                     sx={{position: 'fixed', bottom: 16, right: 16}}>
                    <KeyboardArrowUp/>
                </Fab>
            </Fade>
        </>

    );
}

export default ScrollTopContainer
